import { apiClient } from './client';
import type { ApiResponse } from '@/types/api';

type LoginRequest = {
  username: string;
  password: string;
  rememberMe?: boolean;
};

type JwtTokenResponse = {
  accessToken: string;
};

export const authApi = {
  login(data: LoginRequest) {
    return apiClient.post<ApiResponse<JwtTokenResponse>>('/api/auth/login', data);
  },
};
